import { render } from "./PantallaGeneral.vue?vue&type=template&id=34f5c8ce&scoped=true"
import script from "./PantallaGeneral.vue?vue&type=script&lang=js"
export * from "./PantallaGeneral.vue?vue&type=script&lang=js"

import "@/assets/css/lp-styles.css?v=1.0.2?vue&type=style&index=0&id=34f5c8ce&scoped=true&lang=css"
import "./PantallaGeneral.vue?vue&type=style&index=1&id=34f5c8ce&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f5c8ce"]])

export default __exports__